import {useMediaQuery, useTheme} from '@mui/material';

/**
 * Custom hook for responsive breakpoint detection
 * Returns true if viewport is mobile (xs, sm), false for desktop (md+)
 */
export const useIsMobile = (): boolean => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('md'));
};
